import { baseFetch } from '../../../api/baseFetch';
import { EmptyResponseSchema } from '../../schemas/EmptyResponseSchema';
import {
  AddOrgAccessToFarmResponseSchema,
  FarmOrgAccessResponseSchema,
  UpdateOrgAccessToFarmResponseSchema,
} from './farm-orgs.schema';

export const getOrgsWithFarmAccess = (
  solarFarmId: number,
  solarFarmOrgId: number,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${solarFarmOrgId}/solar_farms/${solarFarmId}/permissions`,
    FarmOrgAccessResponseSchema.defined(),
    {
      searchParams: {
        user_type: 'org',
      },
      headers: {
        'Cache-Control': 'max-age=0',
      },
    },
  );
};

export const addOrgAccessToFarm = (
  solarFarmId: number,
  solarFarmOrgId: number,
  orgIdToAdd: number,
  canOrgEdit: boolean,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${solarFarmOrgId}/solar_farms/${solarFarmId}/permissions`,
    AddOrgAccessToFarmResponseSchema.defined(),
    {
      method: 'POST',
      requestBody: {
        user_type: 'org',
        role_id: canOrgEdit ? 'editor' : 'viewer',
        user_id: `${orgIdToAdd}`,
      },
    },
  );
};

export const updateOrgAccessToFarm = (
  solarFarmId: number,
  solarFarmOrgId: number,
  orgId: number,
  permissionId: number,
  canOrgEdit: boolean,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${solarFarmOrgId}/solar_farms/${solarFarmId}/permissions/${permissionId}/role`,
    UpdateOrgAccessToFarmResponseSchema.defined(),
    {
      method: 'PATCH',
      requestBody: {
        user_type: 'org',
        role_id: canOrgEdit ? 'editor' : 'viewer',
        user_id: `${orgId}`,
      },
    },
  );
};

export const removeOrgAccessToFarm = (
  solarFarmId: number,
  solarFarmOrgId: number,
  permissionId: number,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${solarFarmOrgId}/solar_farms/${solarFarmId}/permissions/${permissionId}`,
    EmptyResponseSchema,
    {
      method: 'DELETE',
    },
  );
};
